import { Plugin } from 'prosemirror-state';
import { Slice, Fragment } from 'prosemirror-model';

const HTTP_LINK_REGEX = new RegExp(
   /(((http|ftp|https):\/{2})+(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b/gimu
);

const pasteHandler = new Plugin({
   props: {
      transformPasted: slice => {
         return new Slice(removeFormatting(slice.content), slice.openStart, slice.openEnd);
      },
   },
});

const removeFormatting = function(fragment) {
   var sanitized = [];

   fragment.forEach(function(child) {
      if (child.isText) {
         const linkMark = child.type.schema.marks['link'];
         child.marks = linkMark.removeFromSet(child.marks);

         sanitized.push(child.copy(child.content));
      } else {
         sanitized.push(child.copy(removeFormatting(child.content)));
      }
   });

   // We're temporarily disabling hyperlink detection on-paste because it
   // makes it difficult to manually use old-style wikitext syntax
   //
   // return linkify(Fragment.fromArray(sanitized));
   return Fragment.fromArray(sanitized);
};

let linkify = function(fragment) {
   var linkified = [];
   fragment.forEach(function(child) {
      if (child.isText) {
         const text = child.text;
         var pos = 0,
            match;

         while ((match = HTTP_LINK_REGEX.exec(text))) {
            var start = match.index;
            var end = start + match[0].length;
            var link = child.type.schema.marks['link'];

            // simply copy across the text from before the match
            if (start > 0) {
               linkified.push(child.cut(pos, start));
            }

            const urlText = text.slice(start, end);
            linkified.push(
               child.cut(start, end).mark(link.create({ href: urlText }).addToSet(child.marks))
            );
            pos = end;
         }

         // copy over whatever is left
         if (pos < text.length) {
            linkified.push(child.cut(pos));
         }
      } else {
         linkified.push(child.copy(linkify(child.content)));
      }
   });

   return Fragment.fromArray(linkified);
};

export default pasteHandler;
